export const board = [
  {
    title: "Dewan Komisaris",
    key: "dewan_komisaris"
  },
  {
    title: "Direksi",
    key: "direksi"
  }
];

export const boardComitee = [
  {
    title: "Dewan Komisaris",
    data: [
      { name: "Mel Gerard Carvill", position: "Komisaris Utama" },
      { name: "I Nyoman Tjager", position: "Komisaris Independen" }
    ]
  },
  {
    title: "Direksi",
    data: [
      { name: "Animesh Narang", position: "Direktur Utama" },
      { name: "Volker Giebitz", position: "Direktur" },
      { name: "Aditya Kesuma", position: "Direktur" },
      { name: "Wiwik Muji Wahyuni", position: "Direktur" },
      { name: "Yusron Anas", position: "Direktur" },
      { name: "Manu Pal Hagalvadi Kshetrapalaiah", position: "Direktur" },
      { name: "Epivania Caroline Galag", position: "Direktur" },
      { name: "Sheldon Chuan Yeh Chiang", position: "Direktur" },
      { name: "Sylvia Lazuarni", position: "Direktur" },
      { name: "Dolly Susanto", position: "Direktur" },
      { name: "Cahyadi Poernomo", position: "Direktur" }
    ]
  }
];
